<!--
slides: [
  {
    img: `${STATIC_URL}images/photo-1466150036782-869a824aeb25.jpeg`,
    url: ""
  },
  {
    img: `${STATIC_URL}images/photo-1474767821094-a8fe9d8c8fdd.jpeg`,
    url: ""
  },
  {
    img: `${STATIC_URL}images/photo-1495073613335-7af8e711f273.jpeg`,
    url: ""
  },
],

-->

<template>
  <div class="slider">
    <ul class="slides" :style="style">
      <li v-for="(slide,i) in playslides" :key="i">
        <a :href="slide.url" target="_blank" class="img" :style="{ backgroundImage: `url(${slide.img})` }"></a>
      </li>
    </ul>
    <div class="progress">
      <div class="line">
        <div class="fill" :style="{ width: `${percent}%`}"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Silder',
  props: {
    images: {
      type: Array,
      default: []
    },
    ms: {
      type: Number,
      default: 3000
    },
  },
  data() {
    return {
      slides: [],
      current: 0,
      percent: 0,
      timer: 0,
      interval: 0,
      progress: 0,
      playslides: []
    }
  },
  computed: {
    style() {
      switch (this.current % 2) {
        case 0:
          return { top: "0" };
        case 1:
          return { top: "-100%" };
      }
    }
  },
  methods: {
    process() {
      this.current++;
      if (this.current >= this.slides.length) {
        this.current = 0;
      }
      this.playslides[this.current % 2] = this.slides[this.current];
      this.resetPlay();
    },
    going() {
      let time = new Date().getTime();
      this.percent = Math.floor(100 * (time - this.timer) / this.ms);
    },
    resetPlay() {
      clearInterval(this.interval);
      clearInterval(this.progress);
      this.play();
    },
    stop() {
      clearInterval(this.interval);
      clearInterval(this.progress);
    },
    play() {
      this.timer = new Date().getTime();
      this.progress = setInterval(this.going, this.ms / 100);
      this.interval = setInterval(this.process, this.ms);
    }
  },
  created() {
    this.slides = [...this.images, ...this.images]

    this.playslides[0] = this.slides[0];
    this.playslides[1] = this.slides[1];
    this.play();
  }
}
</script>

<style lang="scss" scoped>
.slider {
  position: relative;
  z-index: 1;
  overflow: hidden;
  height: 100%;

  ul.slides {
    list-style: none;
    position: absolute;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    transition: top 800ms;

    li {
      height: 100%;

      .img {
        display: block;
        height: 100%;
        background-size: cover;
        background-position: 50%;
      }
    }
  }

  .progress {
    position: absolute;
    bottom: 2px;
    width: 100%;
    height: 2px;
    padding: 0 10px;

    .line {
      height: 100%;
      width: 100%;
      background: rgba(255, 255, 255, .5);
    }

    .fill {
      height: 100%;
      background: #FFDD00;
    }
  }
}
</style>
